import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

class InputTexto extends Component {
    constructor(props) {
        super(props);
        this.inputRef = createRef();
        this._cursorPos = null;
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this._cursorPos = event.target.selectionStart;
        const { onChange } = this.props;
        if (onChange) onChange(event);
    }

    componentDidUpdate() {
        if (this._cursorPos !== null && this.inputRef.current) {
            this.inputRef.current.setSelectionRange(this._cursorPos, this._cursorPos);
            this._cursorPos = null;
        }
    }

    render() {
        const { name, className, value, onKeyDown, readOnly, maxTamagno, tabRef } = this.props;

        return (
            <input
                name={name}
                className={className || "fr_componente"}
                type="text"
                value={value}
                onChange={this.handleChange}
                ref={(el) => {
                    this.inputRef.current = el;
                    if (tabRef) {
                        if (typeof tabRef === 'function') tabRef(el);
                        else tabRef.current = el;
                    }
                }}
                onKeyDown={onKeyDown}
                readOnly={readOnly}
                {...(maxTamagno && maxTamagno > 0 ? { maxLength: maxTamagno } : {})}
            />
        );
    }
}

InputTexto.propTypes = {
    /** Atributo name del input, usado también para identificarlo en el formulario */
    name: PropTypes.string.isRequired,
    /** Valor controlado del input */
    value: PropTypes.string.isRequired,
    /** Callback ejecutado al cambiar el valor */
    onChange: PropTypes.func.isRequired,
    /** Clase CSS del input */
    className: PropTypes.string,
    /** Callback ejecutado al pulsar una tecla */
    onKeyDown: PropTypes.func,
    /** Si el input es de solo lectura */
    readOnly: PropTypes.bool,
    /** Longitud máxima permitida. Si es 0 o negativo, no se aplica límite */
    maxTamagno: PropTypes.number,
    /** Ref externo para el sistema de navegación por tabs (getTab) */
    tabRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ]),
};

InputTexto.defaultProps = {
    className: "fr_componente",
    onKeyDown: null,
    readOnly: false,
    maxTamagno: 0,
    tabRef: null,
};

export default InputTexto;